import { useCallback } from "react"
import axiosInstance from "../axiosInstance"

const useResetMemory = () => {
    return useCallback((id) => {
      const baseUrl = window.localStorage.getItem("BaseURL")

      const endpointClearChat = "/services/projectmanagement/api/ai-bot/chat/clear-chat/" + id
      const fullUrlClearChat = baseUrl + endpointClearChat;

      const endpointResetMemory = "/services/projectmanagement/api/ai-bot/chat/reset-memory/" + id
      const fullUrlResetMemory = baseUrl + endpointResetMemory;

      return new Promise((resolve, reject) => {
        axiosInstance
          .post(fullUrlClearChat)
          .then(() => {
            axiosInstance
              .post(fullUrlResetMemory)
              .then((res) => resolve(res.data))
              .catch(reject)
          })
          .catch(reject)
      })
  }, []);
}

export default useResetMemory 
